import NewPile from './piles/NewPile';
import UsedPile from './piles/UsedPile';
import CandyPile from './piles/CandyPile';
import ComputerPlayerTop from './players/ComputerPlayerTop';
import ComputerPlayerLeft from './players/ComputerPlayerLeft';
import ComputerPlayerRight from './players/ComputerPlayerRight';
import MyPlayerBottom from './players/MyPlayerBottom';
import Constants from './../constants/Constants';
import LocalStorage from '../../local-storage/LocalStorage';

export default class EntitiesRepository {

    constructor(gameCtx) {
        this.gameCtx = gameCtx;
        this.entities = [];
        this.maxCardsForEachPlayer = Constants.TOTAL_CARDS / Constants.TOTAL_PLAYERS;

        this.gameFactory = {
            entities: [
                {
                    id: Constants.NEW_PILE_INDEX,
                    class: NewPile,
                    left: 30, top: 29.5,
                    name: "New Pile",
                    posMethod: Constants.METHOD_PERCENTAGE,
                    maxCards: Constants.TOTAL_CARDS_IN_NEW_PILE
                },
                {
                    id: Constants.CANDY_PILE_INDEX,
                    class: CandyPile,
                    name: "Candy Pile",
                    left: 50, top: 29.5,
                    posMethod: Constants.METHOD_PERCENTAGE,
                },
                {
                    id: Constants.USED_PILE_INDEX,
                    class: UsedPile,
                    left: 40, top: 50,
                    name: "Used Pile",
                    posMethod: Constants.METHOD_PERCENTAGE,
                    maxCards: Constants.TOTAL_CARDS
                },
                {
                    id: Constants.COMPUTER_PLAYER_RIGHT_INDEX,
                    class: ComputerPlayerRight,
                    name: "",
                    maxCards: this.maxCardsForEachPlayer
                },
                {
                    id: Constants.COMPUTER_PLAYER_TOP_INDEX,
                    class: ComputerPlayerTop,
                    name: "",
                    maxCards: this.maxCardsForEachPlayer
                },
                {
                    id: Constants.COMPUTER_PLAYER_LEFT_INDEX,
                    class: ComputerPlayerLeft,
                    name: "",
                    maxCards: this.maxCardsForEachPlayer
                },
                {
                    id: Constants.MY_PLAYER_INDEX,
                    class: MyPlayerBottom,
                    name: LocalStorage.getItem("name"),
                    maxCards: this.maxCardsForEachPlayer
                }
            ]
        }

        this.generateEntities();
    }

    generateEntities = () => {
        this.gameFactory.entities.forEach((entityConf, i, ) => {
            let entity = new entityConf.class(
                this.gameCtx,
                i,
                { ...entityConf }
            );
            this.entities.push(entity);
        });
    }

    getMyPlayer = () => {
        return this.entities[Constants.MY_PLAYER_INDEX];
    }

    getPlayers = () => {
        return [
            this.entities[Constants.COMPUTER_PLAYER_TOP_INDEX],
            this.entities[Constants.COMPUTER_PLAYER_RIGHT_INDEX],
            this.entities[Constants.MY_PLAYER_INDEX],
            this.entities[Constants.COMPUTER_PLAYER_LEFT_INDEX]];
    }

    getNewPile = () => {
        return this.entities[Constants.NEW_PILE_INDEX];
    }

    getUsedPile = () => {
        return this.entities[Constants.USED_PILE_INDEX];
    }

    getCandyPile = () => {
        return this.entities[Constants.CANDY_PILE_INDEX];
    }

    getEntities = () => {
        return this.entities;
    }

    getEntityByIndex = (i) => {
        return this.entities[i];
    }
    getPiles=()=>{
        return[
            this.entities[Constants.NEW_PILE_INDEX],
            this.entities[Constants.USED_PILE_INDEX],
            this.entities[Constants.CANDY_PILE_INDEX]
        ]
    }
}